import apiConfig from '@constants/apiConfig';

import ListDevicePage from '.';

export default {
    listKitPlayDevicePage: {
        path: '/kitplay-device',
        title: 'Device Management',
        auth: true,
        component: ListDevicePage,
        permission: [apiConfig.kitplayDevice.getList.baseURL],
    },
};
